<time  [attr.datetime]="currentDate">
  @if (formattedTime) {
    {{ formattedTime }}
  }

  @if (!formattedTime) {
    <mibp-resource-string [key]="resourceStringKey" [macros]="{ count: number }"></mibp-resource-string>
  }
</time>
